import { createStore } from 'vuex'
import { decompress } from 'shrink-string'

export default createStore({
  state: {
    url: '',
    loads: {},
    Role: null,
    userlist: [],
    FolderList: [],
    AllProjectList: [],
    folder: null,
    folderData: null,
    project: null,
    allIndexData: null,
    loaderText: ''
  },
  mutations: {
    setLoaderText(state, value) {
      state.loaderText = value
    },
    setAllIndexData(state, value) {
      state.allIndexData = value
    },
    setUrl(state, url) {
      state.url = url
    },
    toggleLoad(state, name) {
      if (state.loads[name])
        delete state.loads[name]
      else
        state.loads[name] = true
    },
    setRole(state, Role) {
      state.Role = Role
    },
    setUserList(state, list) {
      state.userlist = list
    },
    setAllProjectList(state, list) {
      state.AllProjectList = list
    },
    setFolderList(state, list) {
      state.FolderList = list
    },
    setFolder(state, value) {
      state.folder = value
      if (!value)
        state.folderData = null
    },
    setFolderData(state, value) {
      state.folderData = value
    },
    setProject(state, value) {
      state.project = value
    },
  },
  actions: {
    reset({ commit }) {
      commit('setRole', false)
    },
    async deleteProject({ state, commit, dispatch }, { url, foldername }) {
      if (!url) return alert('Проект не указан')
      if (!foldername) return alert('Папка не указана')
      commit('toggleLoad', 'deleteproject')
      await fetch(state.url + 'project', {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ url: url, folder: foldername })
      }).then(async res => {
        if (!res.ok) throw (await res.text())
      }).then(() => {
        commit('setProject', null)
        dispatch('updateFoldersData')
      })
        .catch(err => { console.error(err); alert(err) })
      commit('toggleLoad', 'deleteproject')
    },
    async setFolderByName({ state, commit }, name) {
      for (let i = 0; i < state.FolderList.length; i++)
        if (state.FolderList[i].name == name) {
          commit('setProject', null)
          return commit('setFolder', state.FolderList[i])
        }
    },
    async checkAuth({ state, commit }) {
      commit('toggleLoad', 'checkAuth')
      await fetch(state.url + 'auth', {
        credentials: 'include',
      })
        .then(res => {
          if (!res.ok) return commit('setRole', false)
          return res.text()
        }).then(role => {
          commit('setRole', role || false)
        }).catch(err => {
          alert(err)
          commit('setRole', false)
        })
      commit('toggleLoad', 'checkAuth')
    },
    async getUserList({ state, commit }) {
      commit('toggleLoad', 'getUserList')
      await fetch(state.url + 'userlist', {
        credentials: 'include',
      })
        .then(async res => {
          if (!res.ok) throw (await res.text())
          return res.json()
        })
        .then(list => commit('setUserList', list))
        .catch(err => { console.error(err); alert(err) })
      commit('toggleLoad', 'getUserList')

    },
    async getAllProjectList({ state, commit }) {
      commit('toggleLoad', 'getAllProjectList')
      await fetch(state.url + 'projectlist', {
        credentials: 'include',
      })
        .then(async res => {
          if (!res.ok) throw (await res.text())
          return res.json()
        })
        .then(list => commit('setAllProjectList', list))
        .catch(err => { alert(err); console.log(err) })
      commit('toggleLoad', 'getAllProjectList')
    },
    async getFolderList({ state, commit, dispatch }) {
      commit('toggleLoad', 'getFolderList')
      await fetch(state.url + 'folderlist', {
        credentials: 'include',
      })
        .then(async res => {
          if (!res.ok) throw (await res.text())
          return res.json()
        })
        .then(async list => {
          if (state.Role == 2)
            await dispatch('getAllProjectList')
          list.sort((a, b) => a.name.localeCompare(b.name))
          commit('setFolderList', list)
        })
        .catch(err => { alert(err); console.log(err) })
      commit('toggleLoad', 'getFolderList')
    },
    async getDeltaData({ state, commit }, { project, dates, returntext = false }) {
      const [datestart, datefinish = dates[0]] = dates;
      const isWholeMap = datestart === null;
      commit('toggleLoad', 'getDeltaData');

      try {
        const url = state.url + `deltaData?folder=${state.folder.name}&project=${encodeURIComponent(project)}&datestart=${encodeURIComponent(datestart)}&datefinish=${encodeURIComponent(datefinish)}`;
        const res = await fetch(url, { credentials: 'include' });
        if (!res.ok) throw new Error(await res.text());

        let data = await res.json();
        data = data.map(el => ({ ...el, date: new Date(el.date) }))
          .sort((a, b) => a.date - b.date);

        const added = new Set();
        const removed = new Set();
        const BATCH_SIZE = 200;

        for (let i = 0; i < data.length; i += BATCH_SIZE) {
          //console.log(`Batch ${i + 1} of ${Math.ceil(data.length / BATCH_SIZE)}`);
          const batch = data.slice(i, i + BATCH_SIZE);
          const decompressedBatch = await Promise.all(
            batch.map(item => decompress(item.delta).then(JSON.parse)
            )
          );

          for (const delta of decompressedBatch) {
            for (const ad of delta.added) {
              if (removed.has(ad)) removed.delete(ad);
              else added.add(ad);
            }
            for (const rm of delta.removed) {
              if (added.has(rm)) added.delete(rm);
              else removed.add(rm);
            }
          }

        }

        const filename = isWholeMap
          ? `map_${project}_${datefinish}.txt`
          : `delta_${project}_${datestart}_${datefinish}.txt`;

        let addedString = ''
        let removedString = ''
        let notfirst = false
        //console.log('making addedString...')
        //console.log(`added size: ${added.size}`)
        for (const add of added) {
          if (notfirst)
            addedString += '\n'
          else
            notfirst = true
          addedString += add
        }
        notfirst = false
        //console.log('making removedString...')
        //console.log(`removed size: ${removed.size}`)
        for (const remove of removed) {
          if (notfirst)
            removedString += '\n'
          else
            notfirst = true
          removedString += remove
        }

        if (returntext) {
          return isWholeMap && removed.size === 0
            ? addedString
            : `Добавлено:\n${addedString}\n\nУдалено:\n${removedString}`;
        }

        const text = isWholeMap && removed.size === 0
          ? addedString
          : `Добавлено:\n${addedString}\n\nУдалено:\n${removedString}`;

        const blob = new Blob([text], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      } catch (err) {
        console.error(err);
        alert(err.message);
      } finally {
        commit('toggleLoad', 'getDeltaData');
      }
    },
    async updateFoldersData({ state, commit, dispatch }, newname) {
      await dispatch('getFolderList')
      if (newname || (state.folder && state.FolderList.find(f => f.name == state.folder)))
        dispatch('setFolderByName', newname || state.folder.name)
      else {
        commit('setProject', null)
        commit('setFolder', null)
      }
    },
    async getProject({ state, commit }, url) {
      commit('toggleLoad', 'getProject')
      await fetch(state.url + `project?url=${encodeURIComponent(url)}&folder=${encodeURIComponent(state.folder.name)}`, {
        credentials: 'include',
      })
        .then(async res => {
          if (!res.ok) throw (await res.text())
          return res.json()
        })
        .then(project => commit('setProject', project))
        .catch(err => { console.error(err); alert(err) })
      commit('toggleLoad', 'getProject')
    }
  },
  getters: {
    loading(state) {
      return Object.keys(state.loads).length > 0
    },
    folderdates(state) {
      if (!state.FolderList || !state.folder) return null
      const pcounts = state.folder.pcounts
      let dates = {}
      for (let count of pcounts) {
        for (let date in count)
          dates[date] = true
      }
      dates = Object.keys(dates).map(el => {
        const [dd, mm, yy] = el.split('/').map(el => parseInt(el))
        return [el, dd + mm * 50 + yy * 1000]
      })
      dates.sort((a, b) => a[1] - b[1])
      dates = dates.map(el => el[0])
      return dates
    },
    projectList(state) {
      if (!state.FolderList || !state.folder) return []
      const copy = state.folder.projects.slice()
      copy.sort((a, b) => a.localeCompare(b))
      return copy
    },
    pages(state) {
      if (!state.project) return []
      return state.project.pages[state.project.pagemode + 0]
    },
    allProjectList(state) {
      if (!state.FolderList) return []
      if (state.Role == 2) return state.AllProjectList
      return Array.from(new Set(state.FolderList.map(el => el.projects).flat()))
    }
  }
})
